import React, { useState, useEffect } from "react";
import {
  withStyles,
  Button,
  Dialog,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  FormControl,
  MenuItem,
  Select,
} from "@material-ui/core/";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { useSelector } from "react-redux";
import {withRouter} from 'react-router-dom';
import CloseIcon from "@material-ui/icons/Close";
import localizedStrings from '../../../../utils/localize';
import Backdrop from "../../../Backdrop";

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });
const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: "#005598",
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow); 

  const DialogContent = withStyles((theme) => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);
  
  const DialogActions = withStyles((theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(1),
    },
  }))(MuiDialogActions);

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const Attendance = (props) => {
  const { open, onHandleClose } = props;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [modalData, setModalData] = useState([]);
  const [statusFilter, setStatusFilter] = useState(284210000);
  const rosterData = useSelector((state) => state.classData.classRoster);
  const dataFetchingStatus = useSelector(
    (state) => state.classData.dataFetchingStatus,
  );
 const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

 const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const getLocalizedStudentStatus = (status) => {
    const statusMap = {
      284210000: "enrolled",
      284210001: "completed",
      284210002: "cancelled",
      284210003: "incomplete",
      284210004: "dropped",
      284210005: "withdrawal",
      284210006: "waitList",
      284210007: "transfer",
      Enrolled: "enrolled",
      Completed: "completed",
      Cancelled: "cancelled",
      Incomplete: "incomplete",
      Dropped: "dropped",
      Tentative: "tentative",
      "Wait List": "waitList",
      Transfer: "transfer",
    };
    const key = statusMap[status];
    if (!key) return status || "";
    return localizedStrings.students.classes.roster.statusOptions?.[key] || status;
  };

  const getLocalizedGradeOption = (gradeOption) => {
    const gradeMap = {
      Grade: "grade",
      "Pass/Fail": "passFail",
      Audit: "audit",
    };
    const key = gradeMap[gradeOption];
    if (!key) return gradeOption || "";
    return localizedStrings.facultyAndStuff.class.gradeOptions?.[key] || gradeOption;
  };

  useEffect(() => {
    if (rosterData && rosterData?.data?.length > 0) {
      const nextModalData = rosterData.data;
      setModalData(nextModalData);
      const hasEnrolled = nextModalData.some(
        (item) => item.ses_studentstatus === 284210000,
      );
      setStatusFilter(
        hasEnrolled ? 284210000 : nextModalData[0]?.ses_studentstatus || "",
      );
      setPage(0);
    } else {
      setModalData([]);
      setStatusFilter("");
    }
  }, [rosterData]);

  const uniqueStatuses = [
    ...new Set(modalData.map((item) => item.ses_studentstatus).filter(Boolean)),
  ];
  const filteredModalData = modalData.filter(
    (item) => item.ses_studentstatus === statusFilter,
  );

  let tableData = "";
  tableData =
    filteredModalData?.length > 0
      ? filteredModalData
          ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((element, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>
                {element['_ses_studentid_value@OData.Community.Display.V1.FormattedValue']}
              </StyledTableCell>
              <StyledTableCell>
                {element._contact_lastname}
              </StyledTableCell>
              <StyledTableCell>
                {element._contact_preferredname}
              </StyledTableCell>
              <StyledTableCell>
                {getLocalizedStudentStatus(element.ses_studentstatus)}
              </StyledTableCell>
              <StyledTableCell>
                {getLocalizedGradeOption(
                  element[
                    "ses_gradeoption@OData.Community.Display.V1.FormattedValue"
                  ],
                )}
              </StyledTableCell>
              <StyledTableCell>
                {element.emailaddress1 ? (
                  <a href={`mailto:${element.emailaddress1}`}>
                    {element.emailaddress1}
                  </a>
                ) : (
                  ""
                )}
              </StyledTableCell>
            </StyledTableRow>
          ))
      : null;

  return (
    <div>
      <Dialog
      onClose={onHandleClose}
      aria-labelledby="Attendance-dialog-title"
      open={open}
      fullWidth
      maxWidth="lg"
      >
     <DialogTitle id="customized-dialog-title" onClose={props.handleClose}>{localizedStrings.students.classes.attendance.attendance}</DialogTitle>
        <DialogContent
         dividers
         >
         <Backdrop show={dataFetchingStatus} />
          <TableContainer
            component={Paper}
            style={{ minHeight: "40vh", marginBottom: "10px" }}
          >
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.studentId}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.lastName}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.preferredName}
                  </StyledTableCell>
                  <StyledTableCell>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      <span>{localizedStrings.students.classes.roster.status}</span>
                      <FormControl style={{ minWidth: 150 }}>
                        <Select
                          value={statusFilter}
                          style={{ color: "white" }}
                          onChange={(event) => {
                            setStatusFilter(event.target.value);
                            setPage(0);
                          }}
                        >
                          {uniqueStatuses.map((statusValue) => (
                            <MenuItem key={statusValue} value={statusValue}>
                              {getLocalizedStudentStatus(statusValue)}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.gradeType}
                  </StyledTableCell>
                  <StyledTableCell>
                    {localizedStrings.students.classes.roster.emailAddress}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>{tableData}</TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            style={{ textTransform: "capitalize" }}
            rowsPerPageOptions={[5, 10, 25, 100]}
            component="div"
            count={filteredModalData?.length > 0 ? filteredModalData?.length : 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage={<span style={{textTransform:"none"}}>{localizedStrings.rows.rowsperpage}</span>}
      
          />
        </DialogContent>
        <DialogActions>
        <Button autoFocus onClick={onHandleClose} color="primary">
        {localizedStrings.students.selectClasses.modalTable.close}
        </Button>
      </DialogActions>
      </Dialog>
    </div>
  );
}


export default withRouter(Attendance);
